import styled, { css } from 'styled-components';

export default styled.tr`
  ${({ error }) => error && css`
    td {
      background: #f2d8d8 !important;
    }
  `}

  &:nth-child(even) {
    td {
      background-color: #47494E;
    }
  }
`;
